import { render, staticRenderFns } from "./SsoUpgptLogin.vue?vue&type=template&id=5add3b80&scoped=true&lang=pug"
import script from "./SsoUpgptLogin.vue?vue&type=script&lang=js"
export * from "./SsoUpgptLogin.vue?vue&type=script&lang=js"
import style0 from "./SsoUpgptLogin.vue?vue&type=style&index=0&id=5add3b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add3b80",
  null
  
)

export default component.exports